module.exports = __webpack_public_path__ + "img/facebook.149a8632.svg";